module.exports = __webpack_public_path__ + "static/img/u459.49410ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/u459.jpg
// module id = 372
// module chunks = 55